var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        require('../../../../node_modules/intersection-observer/intersection-observer');
        IntersectionObserver.THROTTLE_TIMEOUT = 100;
        IntersectionObserver.USE_MUTATION_OBSERVER = true;

        if (window.NodeList && !NodeList.prototype.forEach) {
            // TOO many error events from browsers that is not supported by us
            // Аdd polyfill while sentry is enabled for them
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (!$.fn.scrollParent) {
            // jquery-ui scrollParent fn
            $.fn.scrollParent = function (includeHidden) {
                var position = this.css('position'),
                    excludeStaticParent = position === 'absolute',
                    overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
                    scrollParent = this.parents().filter(function () {
                    var parent = $(this);
                    if (excludeStaticParent && parent.css('position') === 'static') {
                        return false;
                    }
                    return overflowRegex.test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
                }).eq(0);

                return position === 'fixed' || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
            };
        }

        // Источник: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
        // https://developer.mozilla.org/ru/docs/Web/API/ParentNode/append
        (function (arr) {
            arr.forEach(function (item) {
                if (item.hasOwnProperty('append')) {
                    return;
                }
                Object.defineProperty(item, 'append', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function append() {
                        var argArr = Array.prototype.slice.call(arguments),
                            docFrag = document.createDocumentFragment();

                        argArr.forEach(function (argItem) {
                            var isNode = argItem instanceof Node;
                            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                        });

                        this.appendChild(docFrag);
                    }
                });
            });
        })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
    }, { "../../../../node_modules/intersection-observer/intersection-observer": 2 }], 2: [function (require, module, exports) {
        /**
         * Copyright 2016 Google Inc. All Rights Reserved.
         *
         * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
         *
         *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
         *
         */
        (function () {
            'use strict';

            // Exit early if we're not running in a browser.

            if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
                return;
            }

            // Exit early if all IntersectionObserver and IntersectionObserverEntry
            // features are natively supported.
            if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

                // Minimal polyfill for Edge 15's lack of `isIntersecting`
                // See: https://github.com/w3c/IntersectionObserver/issues/211
                if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                    Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                        get: function get() {
                            return this.intersectionRatio > 0;
                        }
                    });
                }
                return;
            }

            /**
             * A local reference to the document.
             */
            var document = window.document;

            /**
             * An IntersectionObserver registry. This registry exists to hold a strong
             * reference to IntersectionObserver instances currently observing a target
             * element. Without this registry, instances without another reference may be
             * garbage collected.
             */
            var registry = [];

            /**
             * The signal updater for cross-origin intersection. When not null, it means
             * that the polyfill is configured to work in a cross-origin mode.
             * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
             */
            var crossOriginUpdater = null;

            /**
             * The current cross-origin intersection. Only used in the cross-origin mode.
             * @type {DOMRect|ClientRect}
             */
            var crossOriginRect = null;

            /**
             * Creates the global IntersectionObserverEntry constructor.
             * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
             * @param {Object} entry A dictionary of instance properties.
             * @constructor
             */
            function IntersectionObserverEntry(entry) {
                this.time = entry.time;
                this.target = entry.target;
                this.rootBounds = ensureDOMRect(entry.rootBounds);
                this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
                this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
                this.isIntersecting = !!entry.intersectionRect;

                // Calculates the intersection ratio.
                var targetRect = this.boundingClientRect;
                var targetArea = targetRect.width * targetRect.height;
                var intersectionRect = this.intersectionRect;
                var intersectionArea = intersectionRect.width * intersectionRect.height;

                // Sets intersection ratio.
                if (targetArea) {
                    // Round the intersection ratio to avoid floating point math issues:
                    // https://github.com/w3c/IntersectionObserver/issues/324
                    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
                } else {
                    // If area is zero and is intersecting, sets to 1, otherwise to 0
                    this.intersectionRatio = this.isIntersecting ? 1 : 0;
                }
            }

            /**
             * Creates the global IntersectionObserver constructor.
             * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
             * @param {Function} callback The function to be invoked after intersection
             *     changes have queued. The function is not invoked if the queue has
             *     been emptied by calling the `takeRecords` method.
             * @param {Object=} opt_options Optional configuration options.
             * @constructor
             */
            function IntersectionObserver(callback, opt_options) {

                var options = opt_options || {};

                if (typeof callback != 'function') {
                    throw new Error('callback must be a function');
                }

                if (options.root && options.root.nodeType != 1) {
                    throw new Error('root must be an Element');
                }

                // Binds and throttles `this._checkForIntersections`.
                this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

                // Private properties.
                this._callback = callback;
                this._observationTargets = [];
                this._queuedEntries = [];
                this._rootMarginValues = this._parseRootMargin(options.rootMargin);

                // Public properties.
                this.thresholds = this._initThresholds(options.threshold);
                this.root = options.root || null;
                this.rootMargin = this._rootMarginValues.map(function (margin) {
                    return margin.value + margin.unit;
                }).join(' ');

                /** @private @const {!Array<!Document>} */
                this._monitoringDocuments = [];
                /** @private @const {!Array<function()>} */
                this._monitoringUnsubscribes = [];
            }

            /**
             * The minimum interval within which the document will be checked for
             * intersection changes.
             */
            IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

            /**
             * The frequency in which the polyfill polls for intersection changes.
             * this can be updated on a per instance basis and must be set prior to
             * calling `observe` on the first target.
             */
            IntersectionObserver.prototype.POLL_INTERVAL = null;

            /**
             * Use a mutation observer on the root element
             * to detect intersection changes.
             */
            IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

            /**
             * Sets up the polyfill in the cross-origin mode. The result is the
             * updater function that accepts two arguments: `boundingClientRect` and
             * `intersectionRect` - just as these fields would be available to the
             * parent via `IntersectionObserverEntry`. This function should be called
             * each time the iframe receives intersection information from the parent
             * window, e.g. via messaging.
             * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
             */
            IntersectionObserver._setupCrossOriginUpdater = function () {
                if (!crossOriginUpdater) {
                    /**
                     * @param {DOMRect|ClientRect} boundingClientRect
                     * @param {DOMRect|ClientRect} intersectionRect
                     */
                    crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
                        if (!boundingClientRect || !intersectionRect) {
                            crossOriginRect = getEmptyRect();
                        } else {
                            crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
                        }
                        registry.forEach(function (observer) {
                            observer._checkForIntersections();
                        });
                    };
                }
                return crossOriginUpdater;
            };

            /**
             * Resets the cross-origin mode.
             */
            IntersectionObserver._resetCrossOriginUpdater = function () {
                crossOriginUpdater = null;
                crossOriginRect = null;
            };

            /**
             * Starts observing a target element for intersection changes based on
             * the thresholds values.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.observe = function (target) {
                var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
                    return item.element == target;
                });

                if (isTargetAlreadyObserved) {
                    return;
                }

                if (!(target && target.nodeType == 1)) {
                    throw new Error('target must be an Element');
                }

                this._registerInstance();
                this._observationTargets.push({ element: target, entry: null });
                this._monitorIntersections(target.ownerDocument);
                this._checkForIntersections();
            };

            /**
             * Stops observing a target element for intersection changes.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.unobserve = function (target) {
                this._observationTargets = this._observationTargets.filter(function (item) {
                    return item.element != target;
                });
                this._unmonitorIntersections(target.ownerDocument);
                if (this._observationTargets.length == 0) {
                    this._unregisterInstance();
                }
            };

            /**
             * Stops observing all target elements for intersection changes.
             */
            IntersectionObserver.prototype.disconnect = function () {
                this._observationTargets = [];
                this._unmonitorAllIntersections();
                this._unregisterInstance();
            };

            /**
             * Returns any queue entries that have not yet been reported to the
             * callback and clears the queue. This can be used in conjunction with the
             * callback to obtain the absolute most up-to-date intersection information.
             * @return {Array} The currently queued entries.
             */
            IntersectionObserver.prototype.takeRecords = function () {
                var records = this._queuedEntries.slice();
                this._queuedEntries = [];
                return records;
            };

            /**
             * Accepts the threshold value from the user configuration object and
             * returns a sorted array of unique threshold values. If a value is not
             * between 0 and 1 and error is thrown.
             * @private
             * @param {Array|number=} opt_threshold An optional threshold value or
             *     a list of threshold values, defaulting to [0].
             * @return {Array} A sorted list of unique and valid threshold values.
             */
            IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
                var threshold = opt_threshold || [0];
                if (!Array.isArray(threshold)) threshold = [threshold];

                return threshold.sort().filter(function (t, i, a) {
                    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
                        throw new Error('threshold must be a number between 0 and 1 inclusively');
                    }
                    return t !== a[i - 1];
                });
            };

            /**
             * Accepts the rootMargin value from the user configuration object
             * and returns an array of the four margin values as an object containing
             * the value and unit properties. If any of the values are not properly
             * formatted or use a unit other than px or %, and error is thrown.
             * @private
             * @param {string=} opt_rootMargin An optional rootMargin value,
             *     defaulting to '0px'.
             * @return {Array<Object>} An array of margin objects with the keys
             *     value and unit.
             */
            IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
                var marginString = opt_rootMargin || '0px';
                var margins = marginString.split(/\s+/).map(function (margin) {
                    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
                    if (!parts) {
                        throw new Error('rootMargin must be specified in pixels or percent');
                    }
                    return { value: parseFloat(parts[1]), unit: parts[2] };
                });

                // Handles shorthand.
                margins[1] = margins[1] || margins[0];
                margins[2] = margins[2] || margins[0];
                margins[3] = margins[3] || margins[1];

                return margins;
            };

            /**
             * Starts polling for intersection changes if the polling is not already
             * happening, and if the page's visibility state is visible.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._monitorIntersections = function (doc) {
                var win = doc.defaultView;
                if (!win) {
                    // Already destroyed.
                    return;
                }
                if (this._monitoringDocuments.indexOf(doc) != -1) {
                    // Already monitoring.
                    return;
                }

                // Private state for monitoring.
                var callback = this._checkForIntersections;
                var monitoringInterval = null;
                var domObserver = null;

                // If a poll interval is set, use polling instead of listening to
                // resize and scroll events or DOM mutations.
                if (this.POLL_INTERVAL) {
                    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
                } else {
                    addEvent(win, 'resize', callback, true);
                    addEvent(doc, 'scroll', callback, true);
                    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
                        domObserver = new win.MutationObserver(callback);
                        domObserver.observe(doc, {
                            attributes: true,
                            childList: true,
                            characterData: true,
                            subtree: true
                        });
                    }
                }

                this._monitoringDocuments.push(doc);
                this._monitoringUnsubscribes.push(function () {
                    // Get the window object again. When a friendly iframe is destroyed, it
                    // will be null.
                    var win = doc.defaultView;

                    if (win) {
                        if (monitoringInterval) {
                            win.clearInterval(monitoringInterval);
                        }
                        removeEvent(win, 'resize', callback, true);
                    }

                    removeEvent(doc, 'scroll', callback, true);
                    if (domObserver) {
                        domObserver.disconnect();
                    }
                });

                // Also monitor the parent.
                if (doc != (this.root && this.root.ownerDocument || document)) {
                    var frame = getFrameElement(doc);
                    if (frame) {
                        this._monitorIntersections(frame.ownerDocument);
                    }
                }
            };

            /**
             * Stops polling for intersection changes.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
                var index = this._monitoringDocuments.indexOf(doc);
                if (index == -1) {
                    return;
                }

                var rootDoc = this.root && this.root.ownerDocument || document;

                // Check if any dependent targets are still remaining.
                var hasDependentTargets = this._observationTargets.some(function (item) {
                    var itemDoc = item.element.ownerDocument;
                    // Target is in this context.
                    if (itemDoc == doc) {
                        return true;
                    }
                    // Target is nested in this context.
                    while (itemDoc && itemDoc != rootDoc) {
                        var frame = getFrameElement(itemDoc);
                        itemDoc = frame && frame.ownerDocument;
                        if (itemDoc == doc) {
                            return true;
                        }
                    }
                    return false;
                });
                if (hasDependentTargets) {
                    return;
                }

                // Unsubscribe.
                var unsubscribe = this._monitoringUnsubscribes[index];
                this._monitoringDocuments.splice(index, 1);
                this._monitoringUnsubscribes.splice(index, 1);
                unsubscribe();

                // Also unmonitor the parent.
                if (doc != rootDoc) {
                    var frame = getFrameElement(doc);
                    if (frame) {
                        this._unmonitorIntersections(frame.ownerDocument);
                    }
                }
            };

            /**
             * Stops polling for intersection changes.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._unmonitorAllIntersections = function () {
                var unsubscribes = this._monitoringUnsubscribes.slice(0);
                this._monitoringDocuments.length = 0;
                this._monitoringUnsubscribes.length = 0;
                for (var i = 0; i < unsubscribes.length; i++) {
                    unsubscribes[i]();
                }
            };

            /**
             * Scans each observation target for intersection changes and adds them
             * to the internal entries queue. If new entries are found, it
             * schedules the callback to be invoked.
             * @private
             */
            IntersectionObserver.prototype._checkForIntersections = function () {
                if (!this.root && crossOriginUpdater && !crossOriginRect) {
                    // Cross origin monitoring, but no initial data available yet.
                    return;
                }

                var rootIsInDom = this._rootIsInDom();
                var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

                this._observationTargets.forEach(function (item) {
                    var target = item.element;
                    var targetRect = getBoundingClientRect(target);
                    var rootContainsTarget = this._rootContainsTarget(target);
                    var oldEntry = item.entry;
                    var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

                    var newEntry = item.entry = new IntersectionObserverEntry({
                        time: now(),
                        target: target,
                        boundingClientRect: targetRect,
                        rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
                        intersectionRect: intersectionRect
                    });

                    if (!oldEntry) {
                        this._queuedEntries.push(newEntry);
                    } else if (rootIsInDom && rootContainsTarget) {
                        // If the new entry intersection ratio has crossed any of the
                        // thresholds, add a new entry.
                        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                            this._queuedEntries.push(newEntry);
                        }
                    } else {
                        // If the root is not in the DOM or target is not contained within
                        // root but the previous entry for this target had an intersection,
                        // add a new record indicating removal.
                        if (oldEntry && oldEntry.isIntersecting) {
                            this._queuedEntries.push(newEntry);
                        }
                    }
                }, this);

                if (this._queuedEntries.length) {
                    this._callback(this.takeRecords(), this);
                }
            };

            /**
             * Accepts a target and root rect computes the intersection between then
             * following the algorithm in the spec.
             * TODO(philipwalton): at this time clip-path is not considered.
             * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
             * @param {Element} target The target DOM element
             * @param {Object} targetRect The bounding rect of the target.
             * @param {Object} rootRect The bounding rect of the root after being
             *     expanded by the rootMargin value.
             * @return {?Object} The final intersection rect object or undefined if no
             *     intersection is found.
             * @private
             */
            IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
                // If the element isn't displayed, an intersection can't happen.
                if (window.getComputedStyle(target).display == 'none') return;

                var intersectionRect = targetRect;
                var parent = getParentNode(target);
                var atRoot = false;

                while (!atRoot && parent) {
                    var parentRect = null;
                    var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

                    // If the parent isn't displayed, an intersection can't happen.
                    if (parentComputedStyle.display == 'none') return null;

                    if (parent == this.root || parent.nodeType == /* DOCUMENT */9) {
                        atRoot = true;
                        if (parent == this.root || parent == document) {
                            if (crossOriginUpdater && !this.root) {
                                if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                                    // A 0-size cross-origin intersection means no-intersection.
                                    parent = null;
                                    parentRect = null;
                                    intersectionRect = null;
                                } else {
                                    parentRect = crossOriginRect;
                                }
                            } else {
                                parentRect = rootRect;
                            }
                        } else {
                            // Check if there's a frame that can be navigated to.
                            var frame = getParentNode(parent);
                            var frameRect = frame && getBoundingClientRect(frame);
                            var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                            if (frameRect && frameIntersect) {
                                parent = frame;
                                parentRect = convertFromParentRect(frameRect, frameIntersect);
                            } else {
                                parent = null;
                                intersectionRect = null;
                            }
                        }
                    } else {
                        // If the element has a non-visible overflow, and it's not the <body>
                        // or <html> element, update the intersection rect.
                        // Note: <body> and <html> cannot be clipped to a rect that's not also
                        // the document rect, so no need to compute a new intersection.
                        var doc = parent.ownerDocument;
                        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
                            parentRect = getBoundingClientRect(parent);
                        }
                    }

                    // If either of the above conditionals set a new parentRect,
                    // calculate new intersection data.
                    if (parentRect) {
                        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
                    }
                    if (!intersectionRect) break;
                    parent = parent && getParentNode(parent);
                }
                return intersectionRect;
            };

            /**
             * Returns the root rect after being expanded by the rootMargin value.
             * @return {ClientRect} The expanded root rect.
             * @private
             */
            IntersectionObserver.prototype._getRootRect = function () {
                var rootRect;
                if (this.root) {
                    rootRect = getBoundingClientRect(this.root);
                } else {
                    // Use <html>/<body> instead of window since scroll bars affect size.
                    var html = document.documentElement;
                    var body = document.body;
                    rootRect = {
                        top: 0,
                        left: 0,
                        right: html.clientWidth || body.clientWidth,
                        width: html.clientWidth || body.clientWidth,
                        bottom: html.clientHeight || body.clientHeight,
                        height: html.clientHeight || body.clientHeight
                    };
                }
                return this._expandRectByRootMargin(rootRect);
            };

            /**
             * Accepts a rect and expands it by the rootMargin value.
             * @param {DOMRect|ClientRect} rect The rect object to expand.
             * @return {ClientRect} The expanded rect.
             * @private
             */
            IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
                var margins = this._rootMarginValues.map(function (margin, i) {
                    return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
                });
                var newRect = {
                    top: rect.top - margins[0],
                    right: rect.right + margins[1],
                    bottom: rect.bottom + margins[2],
                    left: rect.left - margins[3]
                };
                newRect.width = newRect.right - newRect.left;
                newRect.height = newRect.bottom - newRect.top;

                return newRect;
            };

            /**
             * Accepts an old and new entry and returns true if at least one of the
             * threshold values has been crossed.
             * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
             *    particular target element or null if no previous entry exists.
             * @param {IntersectionObserverEntry} newEntry The current entry for a
             *    particular target element.
             * @return {boolean} Returns true if a any threshold has been crossed.
             * @private
             */
            IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

                // To make comparing easier, an entry that has a ratio of 0
                // but does not actually intersect is given a value of -1
                var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
                var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

                // Ignore unchanged ratios
                if (oldRatio === newRatio) return;

                for (var i = 0; i < this.thresholds.length; i++) {
                    var threshold = this.thresholds[i];

                    // Return true if an entry matches a threshold or if the new ratio
                    // and the old ratio are on the opposite sides of a threshold.
                    if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
                        return true;
                    }
                }
            };

            /**
             * Returns whether or not the root element is an element and is in the DOM.
             * @return {boolean} True if the root element is an element and is in the DOM.
             * @private
             */
            IntersectionObserver.prototype._rootIsInDom = function () {
                return !this.root || containsDeep(document, this.root);
            };

            /**
             * Returns whether or not the target element is a child of root.
             * @param {Element} target The target element to check.
             * @return {boolean} True if the target element is a child of root.
             * @private
             */
            IntersectionObserver.prototype._rootContainsTarget = function (target) {
                return containsDeep(this.root || document, target) && (!this.root || this.root.ownerDocument == target.ownerDocument);
            };

            /**
             * Adds the instance to the global IntersectionObserver registry if it isn't
             * already present.
             * @private
             */
            IntersectionObserver.prototype._registerInstance = function () {
                if (registry.indexOf(this) < 0) {
                    registry.push(this);
                }
            };

            /**
             * Removes the instance from the global IntersectionObserver registry.
             * @private
             */
            IntersectionObserver.prototype._unregisterInstance = function () {
                var index = registry.indexOf(this);
                if (index != -1) registry.splice(index, 1);
            };

            /**
             * Returns the result of the performance.now() method or null in browsers
             * that don't support the API.
             * @return {number} The elapsed time since the page was requested.
             */
            function now() {
                return window.performance && performance.now && performance.now();
            }

            /**
             * Throttles a function and delays its execution, so it's only called at most
             * once within a given time period.
             * @param {Function} fn The function to throttle.
             * @param {number} timeout The amount of time that must pass before the
             *     function can be called again.
             * @return {Function} The throttled function.
             */
            function throttle(fn, timeout) {
                var timer = null;
                return function () {
                    if (!timer) {
                        timer = setTimeout(function () {
                            fn();
                            timer = null;
                        }, timeout);
                    }
                };
            }

            /**
             * Adds an event handler to a DOM node ensuring cross-browser compatibility.
             * @param {Node} node The DOM node to add the event handler to.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to add.
             * @param {boolean} opt_useCapture Optionally adds the even to the capture
             *     phase. Note: this only works in modern browsers.
             */
            function addEvent(node, event, fn, opt_useCapture) {
                if (typeof node.addEventListener == 'function') {
                    node.addEventListener(event, fn, opt_useCapture || false);
                } else if (typeof node.attachEvent == 'function') {
                    node.attachEvent('on' + event, fn);
                }
            }

            /**
             * Removes a previously added event handler from a DOM node.
             * @param {Node} node The DOM node to remove the event handler from.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to remove.
             * @param {boolean} opt_useCapture If the event handler was added with this
             *     flag set to true, it should be set to true here in order to remove it.
             */
            function removeEvent(node, event, fn, opt_useCapture) {
                if (typeof node.removeEventListener == 'function') {
                    node.removeEventListener(event, fn, opt_useCapture || false);
                } else if (typeof node.detatchEvent == 'function') {
                    node.detatchEvent('on' + event, fn);
                }
            }

            /**
             * Returns the intersection between two rect objects.
             * @param {Object} rect1 The first rect.
             * @param {Object} rect2 The second rect.
             * @return {?Object|?ClientRect} The intersection rect or undefined if no
             *     intersection is found.
             */
            function computeRectIntersection(rect1, rect2) {
                var top = Math.max(rect1.top, rect2.top);
                var bottom = Math.min(rect1.bottom, rect2.bottom);
                var left = Math.max(rect1.left, rect2.left);
                var right = Math.min(rect1.right, rect2.right);
                var width = right - left;
                var height = bottom - top;

                return width >= 0 && height >= 0 && {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height
                } || null;
            }

            /**
             * Shims the native getBoundingClientRect for compatibility with older IE.
             * @param {Element} el The element whose bounding rect to get.
             * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
             */
            function getBoundingClientRect(el) {
                var rect;

                try {
                    rect = el.getBoundingClientRect();
                } catch (err) {
                    // Ignore Windows 7 IE11 "Unspecified error"
                    // https://github.com/w3c/IntersectionObserver/pull/205
                }

                if (!rect) return getEmptyRect();

                // Older IE
                if (!(rect.width && rect.height)) {
                    rect = {
                        top: rect.top,
                        right: rect.right,
                        bottom: rect.bottom,
                        left: rect.left,
                        width: rect.right - rect.left,
                        height: rect.bottom - rect.top
                    };
                }
                return rect;
            }

            /**
             * Returns an empty rect object. An empty rect is returned when an element
             * is not in the DOM.
             * @return {ClientRect} The empty rect.
             */
            function getEmptyRect() {
                return {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: 0,
                    height: 0
                };
            }

            /**
             * Ensure that the result has all of the necessary fields of the DOMRect.
             * Specifically this ensures that `x` and `y` fields are set.
             *
             * @param {?DOMRect|?ClientRect} rect
             * @return {?DOMRect}
             */
            function ensureDOMRect(rect) {
                // A `DOMRect` object has `x` and `y` fields.
                if (!rect || 'x' in rect) {
                    return rect;
                }
                // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
                // for internally calculated Rect objects. For the purposes of
                // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
                // for these fields.
                return {
                    top: rect.top,
                    y: rect.top,
                    bottom: rect.bottom,
                    left: rect.left,
                    x: rect.left,
                    right: rect.right,
                    width: rect.width,
                    height: rect.height
                };
            }

            /**
             * Inverts the intersection and bounding rect from the parent (frame) BCR to
             * the local BCR space.
             * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
             * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
             * @return {ClientRect} The local root bounding rect for the parent's children.
             */
            function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
                var top = parentIntersectionRect.top - parentBoundingRect.top;
                var left = parentIntersectionRect.left - parentBoundingRect.left;
                return {
                    top: top,
                    left: left,
                    height: parentIntersectionRect.height,
                    width: parentIntersectionRect.width,
                    bottom: top + parentIntersectionRect.height,
                    right: left + parentIntersectionRect.width
                };
            }

            /**
             * Checks to see if a parent element contains a child element (including inside
             * shadow DOM).
             * @param {Node} parent The parent element.
             * @param {Node} child The child element.
             * @return {boolean} True if the parent node contains the child node.
             */
            function containsDeep(parent, child) {
                var node = child;
                while (node) {
                    if (node == parent) return true;

                    node = getParentNode(node);
                }
                return false;
            }

            /**
             * Gets the parent node of an element or its host element if the parent node
             * is a shadow root.
             * @param {Node} node The node whose parent to get.
             * @return {Node|null} The parent node or null if no parent exists.
             */
            function getParentNode(node) {
                var parent = node.parentNode;

                if (node.nodeType == /* DOCUMENT */9 && node != document) {
                    // If this node is a document node, look for the embedding frame.
                    return getFrameElement(node);
                }

                if (parent && parent.nodeType == 11 && parent.host) {
                    // If the parent is a shadow root, return the host element.
                    return parent.host;
                }

                if (parent && parent.assignedSlot) {
                    // If the parent is distributed in a <slot>, return the parent of a slot.
                    return parent.assignedSlot.parentNode;
                }

                return parent;
            }

            /**
             * Returns the embedding frame element, if any.
             * @param {!Document} doc
             * @return {!Element}
             */
            function getFrameElement(doc) {
                try {
                    return doc.defaultView && doc.defaultView.frameElement || null;
                } catch (e) {
                    // Ignore the error.
                    return null;
                }
            }

            // Exposes the constructors globally.
            window.IntersectionObserver = IntersectionObserver;
            window.IntersectionObserverEntry = IntersectionObserverEntry;
        })();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var toursShortIdStorage = {};

        function isStorageSupported(key) {
            try {
                if (!(key in window)) {
                    return false;
                }
                if (_typeof(window[key]) !== 'object') {
                    return false;
                }

                var testKey = 'test';
                var storage = window.localStorage;
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                return true;
            } catch (error) {
                return false;
            }
        }

        window.utils = {
            /**
             * @param {*} data
             * @return {boolean}
             */
            isObject: function isObject(data) {
                return (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' && data !== null;
            },
            /** @type {boolean} */
            isLocalStorageSupported: isStorageSupported('localStorage'),
            /** @type {boolean} */
            isSessionStorageSupported: isStorageSupported('sessionStorage'),
            cookies: {
                /**
                 * Возвращает cookie с именем name, если есть, если нет, то undefined
                 * @param {string} name
                 * @return {any|undefined}
                 */
                get: function get(name) {
                    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
                    return matches ? decodeURIComponent(matches[1]) : undefined;
                },
                /**
                 * options.expires in seconds
                 *
                 * @param {string} name
                 * @param {*} value
                 * @param {{
                 *  expires: number,
                 * }} options
                 */
                set: function set(name, value, options) {
                    options = options || {};

                    var expires = options.expires; // seconds
                    if (typeof expires === 'number' && expires) {
                        var d = new Date();
                        d.setTime(d.getTime() + expires * 1000);
                        expires = options.expires = d;
                    }
                    if (expires && expires.toUTCString) {
                        options.expires = expires.toUTCString();
                    }

                    value = encodeURIComponent(value);

                    var updatedCookie = name + "=" + value;

                    for (var propName in options) {
                        updatedCookie += "; " + propName;
                        var propValue = options[propName];
                        if (propValue !== true) {
                            updatedCookie += "=" + propValue;
                        }
                    }

                    document.cookie = updatedCookie;
                }
            },
            getnoun: function getnoun(number, one, two, five, glue) {
                number = Math.abs(number);
                number = number % 100;
                glue = glue ? '' + number + ' ' : '';
                if (number >= 5 && number <= 20) {
                    return glue + five;
                }

                number = number % 10;
                if (number === 1) {
                    return glue + one;
                }

                if (number >= 2 && number <= 4) {
                    return glue + two;
                }

                return glue + five;
            },
            /**
             * @param obj
             * @return {number}
             */
            count: function count(obj) {
                if (obj.hasOwnProperty('length')) {
                    return obj.length;
                }
                var res = 0;
                var key = void 0;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) res++;
                }

                return res;
            },
            cl: function cl(text) {
                console.log(text);
            },
            nf: function nf(val) {
                return ('' + val).replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
            },
            nfm: function nfm(val, min) {
                if (!min) {
                    min = 10000;
                }
                return Number(val) >= min ? window.utils.nf(val) : val;
            },
            ksort: function ksort(w, sort_function) {
                var sArr = [];
                var tArr = [];
                var n = 0;

                for (var i in w) {
                    tArr[n++] = i;
                }

                if (sort_function && typeof sort_function == "function") {
                    tArr = tArr.sort(sort_function);
                } else {
                    tArr = tArr.sort();
                }

                for (var _i = 0, _n = tArr.length; _i < _n; _i++) {
                    sArr[tArr[_i]] = w[tArr[_i]];
                }

                return sArr;
            },
            isElementInPopup: function isElementInPopup($el) {
                return !!$el.closest(window.app.isMobile ? '.m-popup' : '.modal').length;
            },
            scrollToElement: function scrollToElement($el, deltaTop) {
                var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

                if ($el.length) {
                    var inPopup = window.utils.isElementInPopup($el);
                    var scrollTop = void 0;
                    var $scrollParent = void 0;
                    if (!inPopup) {
                        $scrollParent = $("html, body");
                        scrollTop = $el.offset().top;
                    } else {
                        $scrollParent = $el.scrollParent();
                        scrollTop = $scrollParent.scrollTop() - $scrollParent.offset().top + $el.offset().top;
                    }
                    $scrollParent.animate({ scrollTop: scrollTop - (deltaTop ? deltaTop : 0) }, duration);
                }
            },
            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            debounce: function debounce(callback, wait) {
                var timeout = void 0;
                return function () {
                    var context = this,
                        args = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        timeout = null;
                        callback.apply(context, args);
                    }, wait);
                    return true;
                };
            },
            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            throttle: function throttle(callback, wait) {
                var lastCallTime = Date.now();
                return function () {
                    if (lastCallTime + wait - Date.now() < 0) {
                        callback.apply(this, arguments);
                        lastCallTime = Date.now();
                    }
                    return true;
                };
            },
            /**
             * @param {string} realId
             * @param {string|jQuery} selector - куда вставить результат (object == jquery object)
             * @param {Function} [callback]
             */
            getShortTourId: function getShortTourId(realId, selector) {
                var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                var $elems = $(selector);
                if ($elems.length) {
                    if (toursShortIdStorage.hasOwnProperty(realId)) {
                        var shortId = toursShortIdStorage[realId];
                        $elems.html('#' + shortId);
                        if (typeof callback === 'function') {
                            callback('#' + shortId);
                        }
                    } else {
                        $elems.html('<img src="/img/load.gif" alt="loading" class="tour-id-loading">');
                        var vUid = window.app.v_uid || '';
                        $.post(window.app.urls.getShortId, { realId: realId, v_uid: vUid }, function (data) {
                            var shortId = realId;
                            if (data && data.success && data.shortId) {
                                shortId = data.shortId;
                            }
                            toursShortIdStorage[realId] = shortId;

                            $elems.html('#' + shortId);
                            if (typeof callback === 'function') {
                                callback('#' + shortId);
                            }
                        }, 'json');
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                }
            },
            /**
             * @param {string} previewSrc
             * @param {string} size - sm|sm4x3|md|big
             * @return {string}
             */
            getHotelPhoto: function getHotelPhoto(previewSrc) {
                var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sm4x3';

                return app.staticDomain + "/img/h/" + size + "/" + previewSrc;
            }
            //     equalHeight: function ($elements, useActual) {
            //         let maxHeight = 0;
            //         $elements.each(function () {
            //             const hh = useActual ? $(this).actual('height') : $(this).height();
            //             if (hh > maxHeight) maxHeight = hh;
            //         });
            //         $elements.height(maxHeight);
            //     },
            //     isElementInViewport (el) {
            //         // special bonus for those using jQuery
            //         if (typeof window.jQuery === "function" && el instanceof window.jQuery) {
            //             el = el[0];
            //         }
            //         const rect = el.getBoundingClientRect();
            //
            //         return rect.top >= 0 &&
            //             rect.left >= 0 &&
            //             rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            //             rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            //         ;
            //     },
            //     isAnyPartOfElementInViewport(el) {
            //         // special bonus for those using jQuery
            //         if (typeof window.jQuery === "function" && el instanceof window.jQuery) {
            //             el = el[0];
            //         }
            //         const rect = el.getBoundingClientRect();
            //         // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
            //         const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            //         const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
            //
            //         // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
            //         const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            //         const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
            //
            //         return (vertInView && horInView);
            //     },
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /*sockets realTime*/
        window.callbacks = {};
        window.c_act_user_id = '';
        window.rtLoginParams = '';
        window.funcs = {};

        function randId() {
            return new Date().getTime() + Math.random();
        }

        //вызовы, запрошенные до события login
        window.rt = {
            connected: false,
            delayed_actions: [],
            afterLogin: {},
            afterClose: {},
            bind: function bind(route, callback) {
                if (route in funcs) {
                    funcs[route].push(callback);
                } else {
                    funcs[route] = [callback];
                }
                return rt;
            },
            trigger: function trigger(route, data) {
                if (route in funcs) {
                    for (var i = 0; i < funcs[route].length; i++) {
                        if (typeof funcs[route][i] === 'function') {
                            funcs[route][i](data);
                        }
                    }
                }
            },
            isOnline: function isOnline() {
                return rt.sock && rt.sock.readyState == 1;
            },
            setLoginParams: function setLoginParams(params) {
                rtLoginParams = params;
            }
        };

        window.rtInit = function () {
            var sockUrl = app.sock.main;
            if (location.hash === '#local' || document.cookie.indexOf('local_ws') !== -1 || document.cookie.indexOf('ws_local') !== -1) {
                sockUrl = app.sock.local;
            }
            rt.sock = new SockJS(sockUrl);
            rt.isLogin = false;
            rt.timer = false;
            rt.go = function (route, data, callback) {
                if (!rt.connected) {
                    rt.delayed_actions.push({
                        route: route,
                        data: data,
                        callback: callback
                    });
                } else {
                    var res = route.split('.');
                    if (callback) {
                        var callbackId = 'callback_' + randId();
                        if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object') {
                            data.clientCallbackId = callbackId;
                        }
                        if (!callbacks[route]) {
                            callbacks[route] = {};
                        }
                        callbacks[route][callbackId] = callback;
                        callbacks[route].lastCallback = callback;
                    }
                    rt.sock.send(JSON.stringify({
                        c: res[0],
                        a: res[1],
                        d: data
                    }));
                }
                return rt;
            };

            rt.sock.onopen = function () {
                rt.connected = true;
                // var now = new Date();
                // console.log('open : ' + now.toString());
                rt.go('app.login', {
                    id: app.id,
                    key: app.key,
                    nid: app.nid,
                    nkey: app.nkey,
                    ukey: app.ukey,
                    bkey: app.bkey,
                    opToken: app.opToken,
                    site: 16,
                    cur: app.currency,
                    loginParams: rtLoginParams,
                    isMobile: app.isMobile,
                    location: window.location.href
                }, function (data) {
                    // var now = new Date();
                    // console.log('login : ' + now.toString());
                    if (data.success) {
                        rt.isLogin = true;
                    }
                    var i = void 0;
                    for (i in rt.afterLogin) {
                        rt.afterLogin[i](data);
                    }
                    if (rt.delayed_actions.length) {
                        for (i = 0; i < rt.delayed_actions.length; i++) {
                            rt.go(rt.delayed_actions[i]['route'], rt.delayed_actions[i]['data'], rt.delayed_actions[i]['callback']);
                        }
                        rt.delayed_actions = [];
                    }
                });
            };

            rt.sock.onmessage = function (e) {
                var data = JSON.parse(e.data);
                if (callbacks[data.r]) {
                    if (data.d && data.d.clientCallbackId) {
                        if (typeof callbacks[data.r][data.d.clientCallbackId] === 'function') {
                            callbacks[data.r][data.d.clientCallbackId](data.d);
                        }
                        delete callbacks[data.r][data.d.clientCallbackId];
                    } else {
                        if (typeof callbacks[data.r].lastCallback === 'function') {
                            callbacks[data.r].lastCallback(data.d);
                        }
                        delete callbacks[data.r];
                    }
                }
                rt.trigger(data.r, data.d ? data.d : {});
            };

            rt.sock.onclose = function () {
                rt.connected = false;
                for (var i in rt.afterClose) {
                    rt.afterClose[i]();
                }
                clearTimeout(rt.timer);
                rt.timer = setTimeout(rtInit, 3000);
            };

            rt.sock.onheartbeat = function () {
                //console.log('heartbeat');
            };
        };
        $(function () {
            rtInit();
        });

        rt.afterLogin['todo.join'] = function (data) {
            if (data.isManager) {
                rt.go('chans.join', { id: 'notify' });
            }
        };
        rt.bind('notify.mess', function (data) {
            if (data) {
                window.utils.cl(data);
            }
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var statLog = [];
        window.tracking = {
            setEvent: function setEvent(eventName) {
                this.setYaEvent(eventName);
                if (eventName && eventName.indexOf('.') !== -1) {
                    var eventParams = eventName.split('.');
                    this.setGAEvent(eventParams[0], eventParams[1]);
                }
            },
            setGAEvent: function setGAEvent(eventCategory, eventAction) {
                var params = {
                    eventCategory: eventCategory
                };
                if (typeof eventAction !== 'undefined') {
                    params.eventAction = eventAction;
                }

                // не используется
                // if (typeof eventLabel !== 'undefined') {
                //     params.eventLabel = eventLabel;
                // }
                // if (typeof eventValue !== 'undefined' && !isNaN(parseInt(eventValue, 10))) {
                //     params.eventValue = eventValue;
                // }

                console.log('setGAEvent:', params);
                if (typeof window.ga !== 'undefined') {
                    // если есть dataLayer, значит установлен google tag manager
                    if (typeof window.dataLayer !== 'undefined' && typeof window.ga.getAll === 'function') {
                        // в идеале надо заменить на window.dataLayer.push({event: 'event-name'}
                        // но так как наш tag manager не настроен до конца, то пока по старому

                        // так как tag manager подменяет собой window.ga и там может быть
                        // несколько счетчиков, ищем там счетчик google аналитики
                        var trackers = window.ga.getAll();
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var tracker = _step.value;

                                if (tracker && tracker.set && tracker.send) {
                                    tracker.send('event', eventCategory, eventAction);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else {
                        window.ga('send', 'event', params);
                    }
                }
            },
            setYaEvent: function setYaEvent(eventName) {
                console.log('setYaEvent: ', eventName);
                if (eventName && typeof window.yaCounter18493072 !== 'undefined') {
                    window.yaCounter18493072.reachGoal(eventName);
                }
            },

            stat: function stat(type, params) {
                if (!app.isProduction) {
                    console.log('stat is disabled for dev mode');
                    return false;
                }
                // если тут ставить window.top.location.href, то падает вебвизор из-за CORS
                var data = {
                    ukey: app.ukey,
                    cityId: app.city && app.city.id ? app.city.id : null,
                    realCityId: app.realCity && app.realCity.id ? app.realCity.id : null,
                    srcId: app.src_id,
                    type: type,
                    href: window.location.href,
                    isFrame: window != window.top,
                    params: params
                };

                if (rt.isOnline()) {
                    rt.go('stat.save', data);
                } else {
                    statLog.push(data);
                    rt.afterLogin.saveStatLog = function () {
                        if (statLog.length) {
                            rt.go('stat.save', statLog);
                            statLog = [];
                        }
                        delete rt.afterLogin.saveStatLog;
                    };
                }
            },
            callTrackingRefresh: function callTrackingRefresh() {
                if (window.roistatCallTrackingRefresh) {
                    window.roistatCallTrackingRefresh();
                }
                window.tracking.refreshWhatsAppLink();
                window.tracking.setRoistatVisitDeviceId();
            },

            /**
             * Сохраняем параметры визита только через этот метод, чтобы не перезаписывать используемые параметры
             * Так как собственные переменные давать нельзя,
             * то используем roistat_param2, roistat_param3, roistat_param4
             */
            setRoistatVisitDeviceId: function setRoistatVisitDeviceId() {
                if (window.roistat) {
                    var params = {};
                    if (window.ymVisitParams && window.ymVisitParams.pageType) {
                        params.roistat_param1 = window.ymVisitParams.pageType;
                    }
                    if (window.amplitude && typeof window.amplitude.getDeviceId() !== 'undefined') {
                        params.roistat_param2 = window.amplitude.getDeviceId();
                    }
                    if (window.app.v_uid) {
                        params.roistat_param3 = window.app.v_uid;
                    }
                    // Нужен для отслеживания оффлайн конверсий ga4
                    var urlParams = new URLSearchParams(window.location.search);
                    var googleClickId = urlParams.get('gclid');
                    if (googleClickId) {
                        params.roistat_param4 = googleClickId;
                    }
                    console.log('roistat set params', params);
                    window.roistat.setRoistatParams(params);
                }
            },

            refreshWhatsAppLink: function refreshWhatsAppLink() {
                if ('roistatGetCookie' in window) {
                    var message = 'Номер заявки: {roistat_visit}. \n' + '\n' + 'Здравствуйте! Пишу вам для подбора тура. \n' + 'Мой запрос: ';
                    var text = message.replace(/{roistat_visit}/g, window.roistatGetCookie('roistat_visit'));
                    text = encodeURI(text);
                    var linkElements = document.querySelectorAll('[href*="//wa.me"]');
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = linkElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var element = _step2.value;

                            var url = element.href;
                            var param = 'text';
                            var value = text;
                            var explodedUrl = url.split('?');
                            var baseUrl = explodedUrl[0] || '';
                            var query = '?' + (explodedUrl[1] || '');
                            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
                            var queryWithoutParameter = query.replace(regex, "$1").replace(/&$/, '');
                            element.href = baseUrl + (queryWithoutParameter.length > 2 ? queryWithoutParameter + '&' : '?') + (value ? param + "=" + value : '');
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var defaultWatchEvents = app.watchEvents || [];

        /**
         * События, на которые добавлена подписка в dom, и их состояние (сработали или нет)
         * @type {{}}
         */
        var domListenersList = {};
        /**
         * События, которые ждут срабатывания
         * @type {Array}
         */
        var listenersList = [];
        /**
         * Подписка на одно или несколько событий одновременно
         * e.g. addScriptReadyListenerOnce(['searchScriptLoaded', 'searchFormInstanceCreated', 'hotTableToursViewInstanceReady'], () => {
         * // do something when all events fired });
         * @param {Array} eventsList
         * @param {Function} callback
         */
        window.addScriptReadyListenerOnce = function (eventsList, callback) {
            listenersList.push({
                dependencies: eventsList,
                callback: callback
            });
            addScriptReadyDomListeners(eventsList);
            // если на момент подписки событие произошло
            dispatchScriptReadyEvents();
        };

        /**
         * @param {string} eventType
         */
        window.setScriptReadyEventOnce = function (eventType) {
            if (!domListenersList.hasOwnProperty(eventType)) {
                // Если никто не подписался на эти события заранее, делаем фейковую подписку,
                // чтобы не пропустить event
                addScriptReadyDomListeners([eventType]);
            }
            $(window).trigger(eventType);
        };

        function dispatchScriptReadyEvents() {
            var notReadyListeners = [];
            for (var i in listenersList) {
                var listener = listenersList[i];
                var ready = true;
                for (var j = 0; j < listener.dependencies.length; j++) {
                    var eventType = listener.dependencies[j];
                    if (!domListenersList.hasOwnProperty(eventType) || domListenersList[eventType] !== true) {
                        ready = false;
                    }
                }
                if (ready) {
                    // все готово
                    listener.callback();
                } else {
                    // откладываем
                    notReadyListeners.push(listener);
                }
            }
            listenersList = notReadyListeners;
        }

        /**
         * @param {Array} eventsList
         */
        function addScriptReadyDomListeners(eventsList) {
            var eventType = void 0;
            for (var i = 0; i < eventsList.length; i++) {
                eventType = eventsList[i];
                if (!domListenersList.hasOwnProperty(eventType)) {
                    domListenersList[eventType] = false;
                    $(window).one(eventType, function (event) {
                        domListenersList[event.type] = true;
                        dispatchScriptReadyEvents();
                    });
                }
            }
        }
        // подписываемся на события при загрузке, чтобы не пропустить
        addScriptReadyDomListeners(defaultWatchEvents);
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var MAP_TYPE_YANDEX = 'yandex';
        var WRAPPER_CSS_CLASS = 'js-map-instance-wrapper';

        //
        //  ============ ============  ============ ============ ============ YANDEX START
        //
        /**
         * Загрузить все необходимое для карт
         * @type {string}
         */
        var YANDEX_API_MAP = 'map';
        /**
         * Загрузить все необходимое для геолокации
         * @type {string}
         */
        var YANDEX_API_GEOLOCATION = 'geolocation';

        var ymapsApiLoader = {
            isLoadStarted: false,
            isLoaded: function isLoaded() {
                return typeof window.ymaps !== 'undefined';
            },
            load: function load() {
                if (ymapsApiLoader.isLoaded()) {
                    ymapsApiLoader.onLoad();
                } else {
                    if (!ymapsApiLoader.isLoadStarted) {
                        ymapsApiLoader.isLoadStarted = true;
                        var apiUrl = ymapsApiLoader.getUrl();
                        $.getScript(apiUrl);
                    }
                }
            },
            getUrl: function getUrl() {
                var apiKey = "&apikey=" + app.yandexMapApiKey;
                // При mode=debug грузит все API сразу, не смотря на package
                var mode = 0 && app.debug ? '&mode=debug' : '';

                // По умолчанию ничего не загружается. Каждый сервис дергается с указанием зависимостей.
                var packages = '';
                // Последня версия 2.1.77 грузит ~700+Кб .js.gz, в не зависимости от package.
                // Список версий: https://tech.yandex.ru/maps/jsapi/doc/2.1/versions/index-docpage/#change-list
                // Зафиксировал 2.1.76, тут еще норм ~80Кб .js.gz базовый. И 170Кб geolocation
                // geolocation + Map,... 310Кб .js.gz
                var loadPackage = "&load=" + packages;
                var onLoadCallback = 'onYaMapApiLoad';
                return "https://api-maps.yandex.ru/2.1.76/?lang=ru_RU&onload=" + onLoadCallback + loadPackage + mode + apiKey;
            },
            onLoad: function onLoad() {
                window.ymapLoader.onApiLoad();
                window.ymapGeolocationLoader.onApiLoad();
            }
        };
        window.onYaMapApiLoad = ymapsApiLoader.onLoad;

        var BaseYMapLoader = function () {
            /**
             * @param {string} packageType
             */
            function BaseYMapLoader(packageType) {
                _classCallCheck(this, BaseYMapLoader);

                /**
                 * @type {string}
                 */
                this.packageType = packageType;

                /**
                 * @type {Array}
                 */
                this.callbacks = [];

                /**
                 * @type {boolean}
                 */
                this.isLoadStarted = false;

                /**
                 * @type {boolean}
                 */
                this.isLoaded = false;
                switch (this.packageType) {
                    case YANDEX_API_GEOLOCATION:
                        this.isLoaded = window.ymaps && window.ymaps.geolocation;
                        break;
                    case YANDEX_API_MAP:
                    default:
                        this.isLoaded = window.ymaps && window.ymaps.Map;
                        break;
                }
            }

            _createClass(BaseYMapLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {}

                /**
                 * @param {Function} callback
                 */

            }, {
                key: "load",
                value: function load(callback) {
                    this.callbacks.push(callback);
                    if (this.isLoaded) {
                        this.onLoad();
                    } else {
                        if (!this.isLoadStarted) {
                            this.isLoadStarted = true;
                            ymapsApiLoader.load();
                        }
                    }
                }
            }, {
                key: "onLoad",
                value: function onLoad() {
                    this.isLoaded = true;
                    if (this.callbacks.length > 0) {
                        for (var i = 0; i < this.callbacks.length; i++) {
                            this.callbacks[i]();
                        }
                    }

                    this.callbacks = [];
                }
            }]);

            return BaseYMapLoader;
        }();

        // -------------> YANDEX GEOLOCATION <-------------


        var YMapGeolocationLoader = function (_BaseYMapLoader) {
            _inherits(YMapGeolocationLoader, _BaseYMapLoader);

            function YMapGeolocationLoader() {
                _classCallCheck(this, YMapGeolocationLoader);

                return _possibleConstructorReturn(this, (YMapGeolocationLoader.__proto__ || Object.getPrototypeOf(YMapGeolocationLoader)).call(this, YANDEX_API_GEOLOCATION));
            }

            _createClass(YMapGeolocationLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {
                    var _this2 = this;

                    var isWaitingGeolocation = !!this.callbacks.length;
                    if (!isWaitingGeolocation) {
                        return false;
                    }
                    if (!window.ymaps.geolocation) {
                        ymaps.ready({
                            require: ['geolocation'],
                            successCallback: function successCallback(ym) {
                                _this2.onLoad();
                            }
                        });
                    } else {
                        this.onLoad();
                    }
                }
            }]);

            return YMapGeolocationLoader;
        }(BaseYMapLoader);
        // -------------> YANDEX GEOLOCATION END <-------------

        // -------------> YANDEX MAP <-------------


        var YMapLoader = function (_BaseYMapLoader2) {
            _inherits(YMapLoader, _BaseYMapLoader2);

            function YMapLoader() {
                _classCallCheck(this, YMapLoader);

                var _this3 = _possibleConstructorReturn(this, (YMapLoader.__proto__ || Object.getPrototypeOf(YMapLoader)).call(this, YANDEX_API_MAP));

                if (typeof window.ymapLoader !== 'undefined') {
                    throw new Error('only one instance of YMapLoader');
                }
                _this3.wrapperCssClass = WRAPPER_CSS_CLASS;
                _this3.type = MAP_TYPE_YANDEX;

                _this3.list = {};
                _this3.mapIndex = 0;
                return _this3;
            }

            _createClass(YMapLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {
                    var _this4 = this;

                    var isWaitingMap = !!this.callbacks.length;
                    if (!isWaitingMap) {
                        return false;
                    }

                    if (!ymaps.Map) {
                        // Пример использования расширенного синтаксиса функции ready.
                        ymaps.ready({
                            // successCallback будет вызван, когда загрузятся API и модуль "myModule1".
                            require: ['Map', 'Placemark', 'data.Manager', 'util.bounds', 'control.ZoomControl', 'geoObject.addon.balloon', 'geoObject.addon.hint'],
                            successCallback: function successCallback(ym) {
                                _this4.onLoad();
                            }
                        });
                    } else {
                        this.onLoad();
                    }
                }
            }, {
                key: "destroy",
                value: function destroy(key) {
                    if (!this.list.hasOwnProperty(key)) {
                        console.warn('unknown map key');
                    }
                    var item = this.list[key];
                    item.instance.destroy();
                    item.$wrapper.removeClass(this.wrapperCssClass);

                    delete this.list[key];
                }

                /**
                 * @param {BaseMap|OfficeMap|OfficeSchemeMap} mapInstance
                 *      (OfficeSchemeMap - старая карта)
                 * @param $wrapper - сюда будет добавлен идентификтор карты, для последующего удаления
                 */

            }, {
                key: "addToStorage",
                value: function addToStorage(mapInstance, $wrapper) {
                    var storageKey = 'yMap' + this.mapIndex;
                    this.list[storageKey] = {
                        instance: mapInstance,
                        $wrapper: $wrapper
                    };

                    $wrapper.data('map-key', storageKey).data('map-type', this.type).addClass(this.wrapperCssClass);

                    this.mapIndex++;
                }
            }]);

            return YMapLoader;
        }(BaseYMapLoader);
        // -------------> YANDEX MAP END <-------------

        //
        //  ============ ============  ============ ============ ============ YANDEX END
        //

        /**
         * Удаляет все карты внутри переданного контейнера
         * Пример: Карта отрисована в модальном окне.
         *   При закрытии модального окна, содержимое будет удалено вместе с модалкой.
         *   Т.о., если HTMLElement внутри которого есть карта,
         *   будет заменен/удален со страницы - будет ошибка (как минимум yandex карты).
         * Если контейнер с картой просто скрывается/показывается - в этом случае наоборот,
         * лучше не карту не удалять,
         * за счет чего можно уменьшить кол-во баллов потраченных на создание новой карты.
         * @param $parent
         */


        window.removeAllMapsInElement = function ($parent) {
            $parent.find('.' + WRAPPER_CSS_CLASS).each(function () {
                var $mapWrapper = $(this);
                var storageKey = $mapWrapper.data('map-key');
                var mapType = $mapWrapper.data('map-type');
                switch (mapType) {
                    case MAP_TYPE_YANDEX:
                        window.ymapLoader.destroy(storageKey);
                        break;
                }
            });
        };

        window.ymapLoader = new YMapLoader();
        window.ymapGeolocationLoader = new YMapGeolocationLoader();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // vanilla js only
        var onDOMContentLoaded = function onDOMContentLoaded() {
            // При попадании блока в область видимости, загрузить картинку|установить фон
            var lazyBackgroundClass = 'lazy-img-bg-watch';
            // При попадании img в область видимости, загрузить картинку
            var lazyImageClass = 'lazy-img-watch';

            var lazyBackgrounds = [].slice.call(document.querySelectorAll('.' + lazyBackgroundClass));
            if ('IntersectionObserver' in window && lazyBackgrounds.length) {
                var lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            // lazy backgroundImage
                            entry.target.style.backgroundImage = "url(" + entry.target.dataset.image + ")";
                            entry.target.classList.remove(lazyBackgroundClass);
                            observer.unobserve(entry.target);
                        }
                    });
                });

                lazyBackgrounds.forEach(function (lazyBackground) {
                    lazyBackgroundObserver.observe(lazyBackground);
                });
            }

            var lazyImages = [].slice.call(document.querySelectorAll('img.' + lazyImageClass));
            if (lazyImages.length) {
                var active = false;
                var lazyLoad = function lazyLoad() {
                    if (active === false) {
                        active = true;

                        setTimeout(function () {
                            lazyImages.forEach(function (lazyImage) {
                                if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {
                                    lazyImage.src = lazyImage.dataset.src;
                                    lazyImage.classList.remove(lazyImageClass);
                                    lazyImage.dataset.loaded = '1';
                                }
                            });

                            lazyImages = lazyImages.filter(function (image) {
                                return image.dataset.loaded !== '1';
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('resize', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }

                            active = false;
                        }, 200);
                    }
                };

                document.addEventListener('scroll', lazyLoad);
                window.addEventListener('resize', lazyLoad);
                window.addEventListener('orientationchange', lazyLoad);
            }

            document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
        };
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

        window.lazyImage = {
            /**
             * @param {HTMLImageElement|Element} lazyImgOrBg
             * @param {boolean} isImg
             */
            load: function load(lazyImgOrBg, isImg) {
                if (isImg) {
                    lazyImgOrBg.src = lazyImgOrBg.dataset.src;
                    lazyImgOrBg.classList.remove('lazy-img');
                    lazyImgOrBg.removeAttribute('data-src');
                } else {
                    lazyImgOrBg.style.backgroundImage = "url(" + lazyImgOrBg.dataset.image + ")";
                    lazyImgOrBg.classList.remove('lazy-img-bg');
                    lazyImgOrBg.removeAttribute('data-image');
                }
            },
            /**
             * @param {Element} parentElem
             * @param {boolean} img  Загрузить img
             * @param {boolean} background Загрузить bg
             */
            loadChildren: function loadChildren(parentElem) {
                var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var background = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                if (!parentElem) {
                    return;
                }
                if (img) {
                    parentElem.querySelectorAll('img.lazy-img').forEach(function (lazyImage) {
                        window.lazyImage.load(lazyImage, true);
                    });
                }
                if (background) {
                    parentElem.querySelectorAll('.lazy-img-bg').forEach(function (lazyImageBg) {
                        window.lazyImage.load(lazyImageBg, false);
                    });
                }
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var callbackRequestFunc = require('../../../include/_js/callback/callback-request-create-fn');
        var CallbackParams = require('../../../include/_js/callback/CallbackParams');

        window.callRequest = {
            Params: CallbackParams,
            // errorFields: callbackParams.errorFields,
            /**
             * @param {CallbackParams} params
             * @param callback
             */
            create: callbackRequestFunc
        };

        window.loadGoogleCaptcha = function () {
            return new Promise(function (resolve, reject) {
                if (typeof grecaptcha !== 'undefined') {
                    resolve();
                    return;
                }

                var script = document.createElement('script');
                script.src = "https://www.google.com/recaptcha/api.js?render=" + window.app.googleCaptchaSiteKey;
                script.async = true;
                script.defer = true;

                script.onload = function () {
                    var waitForGrecaptcha = setInterval(function () {
                        if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
                            clearInterval(waitForGrecaptcha);
                            resolve();
                        }
                    }, 100);
                };

                script.onerror = function (error) {
                    return reject(new Error('Failed to load reCAPTCHA'));
                };

                document.head.appendChild(script);
            });
        };
    }, { "../../../include/_js/callback/CallbackParams": 2, "../../../include/_js/callback/callback-request-create-fn": 3 }], 2: [function (require, module, exports) {
        var FIELD_PHONE = 'phone';
        var FIELD_DATE_TIME = 'dateTime';

        var win = window;

        var PHONE_LENGTH = 10;
        function clearPhone(phone) {
            return ('' + phone).trim()
            // remove phone mask code
            .replace('+7', '').replace(/\D/g, '');
        }

        var CallbackParams = function () {
            function CallbackParams(params) {
                _classCallCheck(this, CallbackParams);

                this.srcId = win.app.src_id ? win.app.src_id : null;
                this.vUid = win.app.v_uid ? win.app.v_uid : '';

                this.clientName = params.hasOwnProperty('clientName') ? params.clientName : '';
                this.cityId = parseInt(params.cityId, 10);
                this.formTypeId = parseInt(params.formTypeId, 10);
                this.phone = params.phone; // Важно сохранить форматирование, для проброса в maskedInput
                this.isChooseCallTime = params.hasOwnProperty('isChooseCallTime') ? parseInt(params.isChooseCallTime, 10) : 0;

                this.callDate = '';
                this.callTime = '';
                this.recaptchaToken = params.recaptchaToken;
                if (this.isChooseCallTime) {
                    this.callDate = params.callDate;
                    this.callTime = params.callTime;
                }

                // Только при изменении времени звонка
                this.requestId = 'requestId' in params ? Number(params.requestId) : null;

                /**
                 * Отдельная "цель" на успешный заказ колебка в YM
                 * @type {string}
                 */
                this.ymConversionEvent = '';
                if (params.ymConversionEvent) {
                    this.setYMConversionEvent(params.ymConversionEvent);
                }
                /**
                 * Отдельная цель на успешный заказ колбека в GA
                 * @type {{eventCategory: string, eventAction: string}|null}
                 */
                this.gaConversionEvent = null;
                if (params.hasOwnProperty('gaConversionEventCategory') && params.hasOwnProperty('gaConversionEventAction')) {
                    this.setGAConversionEvent(params.gaConversionEventCategory, params.gaConversionEventAction);
                }

                this.errorList = {};
                this.errorList[FIELD_PHONE] = {
                    error: false,
                    message: ''
                };
                this.errorList[FIELD_DATE_TIME] = {
                    error: false,
                    message: ''
                };
            }

            _createClass(CallbackParams, [{
                key: "setYMConversionEvent",
                value: function setYMConversionEvent(eventKey) {
                    this.ymConversionEvent = eventKey;
                }
            }, {
                key: "setGAConversionEvent",
                value: function setGAConversionEvent(eventCategory, eventAction) {
                    if (!eventCategory || !eventCategory) {
                        return;
                    }
                    this.gaConversionEvent = {
                        category: eventCategory,
                        action: eventAction
                    };
                }
            }, {
                key: "validate",
                value: function validate() {
                    var isValid = true;
                    if (this.isChooseCallTime) {
                        if (this.callDate === '' || this.callTime === '') {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        } else if (parseInt(this.callTime, 10) === -1) {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        }
                    }

                    if (clearPhone(this.phone).length !== PHONE_LENGTH) {
                        isValid = false;
                        this._addError(FIELD_PHONE, 'Проверьте номер телефона');
                    }

                    return isValid;
                }

                /**
                 *
                 * @param formFields - e.g. $form.serializeArray()
                 * @return {CallbackParams}
                 */

            }, {
                key: "haveError",


                /**
                 * @param {string} field
                 * @return {boolean}
                 */
                value: function haveError(field) {
                    return this.errorList[field].error;
                }
            }, {
                key: "_addError",
                value: function _addError(field, message) {
                    if (!this.errorList.hasOwnProperty(field)) {
                        return false;
                    }

                    this.errorList[field].error = true;
                    this.errorList[field].message = message;
                }
            }, {
                key: "errorFields",
                get: function get() {
                    return {
                        PHONE: FIELD_PHONE,
                        DATETIME: FIELD_DATE_TIME
                    };
                }

                /**
                 * Первое сообщение об ошибке
                 * @return {{field: string, message: string}}
                 */

            }, {
                key: "error",
                get: function get() {
                    var data = { field: '', message: '' };
                    if (this.errorList.phone.error) {
                        data.field = FIELD_PHONE;
                        data.message = this.errorList.phone.message;
                    } else if (this.errorList.dateTime.error) {
                        data.field = FIELD_DATE_TIME;
                        data.message = this.errorList.dateTime.message;
                    }

                    return data;
                }
            }], [{
                key: "loadForm",
                value: function loadForm(formFields) {
                    var params = {};
                    for (var i in formFields) {
                        var field = formFields[i];
                        params[field.name] = field.value;
                    }

                    return new CallbackParams(params);
                }
            }]);

            return CallbackParams;
        }();

        module.exports = CallbackParams;
    }, {}], 3: [function (require, module, exports) {
        var ERROR_NOT_WORKING_TIME = 'not_working_time';
        var ERROR_NON_CORRECT_DATA = 'non_correct_data';
        var ERROR_EXIST = 'callback exist timeout';

        var CallbackRequestEntity = function CallbackRequestEntity(props) {
            _classCallCheck(this, CallbackRequestEntity);

            /** @type number */
            this.id = props.id;
            /** @type string */
            this.callDate = props.callDate;
            /** @type string */
            this.callTime = props.callTime;
            /** @type string */
            this.callDateTimeDescription = props.callDateTimeDescription;
            /** @type {boolean} */
            this.allowChangeCallTime = props.allowChangeCallTime;
        };

        var CallbackCreateResponse = function CallbackCreateResponse() {
            _classCallCheck(this, CallbackCreateResponse);

            this.success = false;
            this.title = '';
            this.message = '';
            /** @type {CallbackRequestEntity|null} */
            this.request = null;
            /** @type {{}|null} */
            this.callTimes = null;
            /** @type {string} */
            this.selectedCallTime = '';
        };

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */


        module.exports = function (params, callback) {
            var response = new CallbackCreateResponse();

            if (!params.validate()) {
                callback(response);
                return;
            }

            var requestParams = {
                srcId: params.srcId,
                vUid: params.vUid,

                cityId: params.cityId,
                formTypeId: params.formTypeId,
                phone: params.phone,
                isChooseCallTime: params.isChooseCallTime
            };
            if (requestParams.isChooseCallTime) {
                requestParams.callDate = params.callDate;
                requestParams.callTime = params.callTime;
            }
            if (params.clientName) {
                requestParams.clientName = params.clientName;
            }

            requestParams.recaptchaToken = params.recaptchaToken;

            $.post(window.app.urls.addCallback, requestParams, function (responseData) {
                if (!responseData.success) {
                    response.title = 'Ошибка';
                    // data.allowRepeat = false;
                    switch (responseData.errorType) {
                        case ERROR_NOT_WORKING_TIME:
                            response.message = 'К сожалению, рабочий день окончен';
                            break;
                        case ERROR_NON_CORRECT_DATA:
                            response.message = 'Введены некорректные данные';
                            break;
                        // case ERROR_EXIST:
                        //     title = 'Мы скоро вам перезвоним';
                        //     // data.allowRepeat = false;
                        //     break;
                        default:
                            response.message = 'Извините, произошла ошибка. Попробуйте позднее';
                            break;
                    }
                } else {
                    response.success = true;
                    response.title = 'Спасибо';
                    response.request = new CallbackRequestEntity(responseData.request);
                    response.callTimes = responseData.callTimes;
                    response.selectedCallTime = responseData.selectedCallTime;
                    if (requestParams.isChooseCallTime) {
                        response.message = 'Наш менеджер свяжется с вами в указанное время';
                    } else {
                        response.message = 'Наш менеджер свяжется с вами в ближайшее время';
                    }

                    // отмечаем что был заказан коллбек
                    window.tracking.setEvent('callback.create');
                    $('body').trigger('callback:success'); // проброс в angular
                    if (params.ymConversionEvent) {
                        window.tracking.setYaEvent(params.ymConversionEvent);
                    }
                    if (params.gaConversionEvent) {
                        var gaEvent = params.gaConversionEvent;
                        window.tracking.setGAEvent(gaEvent.category, gaEvent.action);
                    }
                }

                callback(response);
            }, 'json');
        };
    }, {}] }, {}, [1]);